import { useLazyGetAllTeamsQuery } from '@/services/tenant/teamManagement'
import { useLazyGetAllWorkGroupsQuery } from '@/services/tenant/workGroups'

export const useWorkGroupOptions = () => {
    const [getWorkGroup, { data: WorkGroupData }] =
        useLazyGetAllWorkGroupsQuery()
    const loadOptionsWorkGroup = async (
        search: string,
        loadedOptions: any,
        { page }: { page: number },
    ) => {
        const res = await getWorkGroup(`page=${page}&search=${search}`).unwrap()

        return {
            options:
                res?.data.map(group => ({
                    value: group?.id,
                    label: group?.name,
                })) || [],
            hasMore: +page !== res?.pagination?.maxPages, // флаг, показывающий, есть ли еще данные
            additional: {
                page: page + 1, // увеличиваем номер страницы для следующего запроса
            },
        }
    }

    return { loadOptionsWorkGroup, WorkGroupData }
}
